export function formDataToObject( data: FormData ): Record<string, FormDataEntryValue | FormDataEntryValue[]> {

  const output: Record<string, FormDataEntryValue | FormDataEntryValue[]> = {};

  data.forEach( ( value, key ) => {

    if ( key in output ) {

      if ( !Array.isArray( output[ key ] ) ) {
        output[ key ] = [ output[ key ] as string ];
      }

      ( output[ key ] as FormDataEntryValue[] ).push( value );

    } else {

      output[ key ] = value;

    }

  } );

  return output;

}
